<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          &copy;{{ new Date().getFullYear() }} KGB Aviation, All Rights Reserved.
          <span v-if="$store.getters.isKgbAdminUser">
            [ Versions UI: {{ version }} API: {{ apiVersion }} ]
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import getReleaseInfo from '@/services/releaseInfo';
import UserClient from '@/api/UserClient';

export default {
  name: 'AppFooter',
  data() {
    return {
      version: 'n/a',
      apiVersion: 'n/a',
      userClient: null,
    };
  },
  mounted() {
    this.userClient = new UserClient(this.$http);

    getReleaseInfo().then((info) => {
      this.version = info.release;
    });

    this.userClient.getApiVersion().then((version) => {
      this.apiVersion = version;
    }).catch(() => {
      // Handle error silently, apiVersion will remain 'n/a'
      console.warn('Failed to fetch API version');
    });
  },
};
</script>

<style scoped lang="scss">
.footer {
  padding: $gutter 0;
  color: rgba(0, 0, 0, 0.5);
  border-top: $default-border;
}
</style>
